import React from 'react';
import {
  Row, Col, Typography, Card, Form, Button, notification,
} from 'antd';
import PropTypes from 'prop-types';
import ArrowLeftIcon from 'mdi-react/ArrowLeftIcon';
import SelectedLands from '../../../../serviceComponents/selectedLands/SelectedLands';
import GeoMapSummary from '../../../../serviceComponents/geoMapSummary/GeoMapSummary';
import './Details.scss';
import DetailsFields from '../detailsEdit/DetailsEdit';

const Details = (props) => {
  const {
    removeSelectedField, serviceRequestParameters, nextPage, previousPage,
  } = props;

  const [formInstance] = Form.useForm();

  const handleSubmit = (values) => {
    const fields = Object.entries(values);
    let verifyValorUnitario = formInstance.getFieldValue('GEOFERT-ZONA-MANEJO-SATELITE-VALOR_UNITARIO');
    let verifyValorTotal = formInstance.getFieldValue('GEOFERT-ZONA-MANEJO-SATELITE-VALOR_TOTAL');
    const verifyCondicaoPagamento = formInstance.getFieldValue('GEOFERT-ZONA-MANEJO-SATELITE-CONDICAO_PAGAMENTO');
    const verifyFormaPagamento = formInstance.getFieldValue('GEOFERT-ZONA-MANEJO-SATELITE-FORMA_PAGAMENTO');

    if (verifyValorUnitario == '0,00') {
      verifyValorUnitario = null;
    }

    if (verifyValorTotal == '0,00') {
      verifyValorTotal = null;
    }

    if (
      (
        (verifyValorUnitario === undefined || verifyValorUnitario === null || verifyValorUnitario === '')
        && (verifyValorTotal === undefined || verifyValorTotal == null || verifyValorTotal === '')
        && (verifyCondicaoPagamento === undefined || verifyCondicaoPagamento === null || verifyCondicaoPagamento === '')
        && (verifyFormaPagamento === undefined || verifyFormaPagamento === null || verifyFormaPagamento === '')
      ) || (
        (verifyValorUnitario !== undefined && verifyValorUnitario !== null && verifyValorUnitario !== '')
        && (verifyValorTotal !== undefined && verifyValorTotal !== null && verifyValorTotal !== '')
        && (verifyCondicaoPagamento !== undefined && verifyCondicaoPagamento !== null && verifyCondicaoPagamento !== '')
        && (verifyFormaPagamento !== undefined && verifyFormaPagamento !== null && verifyFormaPagamento !== '')
      )
    ) {
      if (
        (verifyValorUnitario !== undefined && verifyValorUnitario !== null && verifyValorUnitario !== '')
        && (verifyValorTotal !== undefined && verifyValorTotal !== null && verifyValorTotal !== '')
      ) {
        fields.map((item) => {
          if (item[0] === 'GEOFERT-ZONA-MANEJO-SATELITE-VALOR_UNITARIO') {
            item[1] = verifyValorUnitario.replaceAll('.', '').replaceAll(',', '.');
          }

          if (item[0] === 'GEOFERT-ZONA-MANEJO-SATELITE-VALOR_TOTAL') {
            item[1] = verifyValorTotal.replaceAll('.', '').replaceAll(',', '.');
          }
        });
      } else {
        fields.map((item) => {
          if (item[0] === 'GEOFERT-ZONA-MANEJO-SATELITE-VALOR_UNITARIO') {
            item[1] = null;
          }

          if (item[0] === 'GEOFERT-ZONA-MANEJO-SATELITE-VALOR_TOTAL') {
            item[1] = null;
          }
        });
      }

      nextPage({
        ...serviceRequestParameters,
        serviceRequestFieldInputList: fields.map((fieldValue) => {
          return ({
            idCode: fieldValue[0],
            value: fieldValue[1] || '',
          });
        }).filter((fieldValue) => {
          return fieldValue.value != null
            || fieldValue.idCode.includes('VALOR_UNITARIO')
            || fieldValue.idCode.includes('VALOR_TOTAL')
            || fieldValue.idCode.includes('CONDICAO_PAGAMENTO')
            || fieldValue.idCode.includes('FORMA_PAGAMENTO')
            || fieldValue.idCode.includes('OBSERVACOES');
        }),
      });
    } else {
      notification.warning({
        message: 'AVISO',
        description: 'Todos os campos referentes aos valores e pagamento do orçamento devem ser preenchidos ou estarem vazios.',
      });
    }
  };

  return (
    <div className="zonaManejoDetails">
      <Row
        justify="space-between"
        className="zonaManejoDetails__TitleRow"
      >
        <Col
          className="zonaManejoDetails__TitleCol"
        >
          <Typography.Title
            level={1}
            className="zonaManejoDetails__Title"
          >
            Novo Serviço: Geofert
          </Typography.Title>
        </Col>
      </Row>
      <Row
        gutter={[24, 24]}
        className="zonaManejoDetails__ContentRow"
      >
        <Col
          span={24}
          className="zonaManejoDetails__ContentColumn"
        >
          <Card
            className="zonaManejoDetails__ContentCard"
          >
            <Row
              gutter={[24, 24]}
              className="zonaManejoDetails__FormRow"
            >
              <Col
                xs={{ span: 24 }}
                lg={{ span: 12 }}
                className="zonaManejoDetails__FormColumn"
              >
                <Form
                  scrollToFirstError
                  className="zonaManejoDetails__Form"
                  layout="vertical"
                  form={formInstance}
                  onFinish={handleSubmit}
                  onFinishFailed={
                    (errorInfo) => {
                      console.log('zonaManejoDetails onFinishFailed', errorInfo);
                    }
                  }
                >
                  <DetailsFields
                    formInstance={formInstance}
                    initialValuesObject={
                      serviceRequestParameters
                        ?.serviceRequestFieldInputList?.length
                        ? Object.fromEntries(
                          serviceRequestParameters
                            ?.serviceRequestFieldInputList
                            ?.map(
                              (val) => {
                                return [val.idCode, val.value];
                              },
                            ),
                        )
                        : undefined
                    }
                  />
                </Form>
              </Col>
              <Col
                xs={{ span: 24 }}
                lg={{ span: 12 }}
                className="zonaManejoDetails__LandAndSummaryColumn"
              >
                <SelectedLands
                  talhoesSelecionados={serviceRequestParameters.talhoesSelecionados}
                  removeSelectedField={removeSelectedField}
                />
                <GeoMapSummary params={serviceRequestParameters} />
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              justify="end"
              className="zonaManejoDetails__ButtonRow"
            >
              <Col
                xs={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 6 }}
                className="zonaManejoDetails__ButtonFirstColumn"
              >
                <Button
                  block
                  className="zonaManejoDetails__BackButton"
                  onClick={() => previousPage()}
                >
                  <ArrowLeftIcon className="zonaManejoDetails__ArrowLeftIcon" />
                  Voltar
                </Button>
              </Col>
              <Col
                xs={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 6 }}
                className="zonaManejoDetails__ButtonSecondColumn"
              >
                <Button
                  block
                  type="primary"
                  htmlType="submit"
                  className="zonaManejoDetails__ContinueButton"
                  onClick={
                    (eventt) => {
                      eventt.preventDefault();
                      formInstance.submit();
                    }
                  }
                >
                  Continuar
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

Details.propTypes = {
  removeSelectedField: PropTypes.func.isRequired,
  nextPage: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,

  serviceRequestParameters: PropTypes.shape({
    serviceRequestFieldInputList: PropTypes.arrayOf(PropTypes.shape({})),
    serviceTypeDynamicFields: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    serviceSubtypeDynamicFields: PropTypes.arrayOf(PropTypes.shape({})),
    service: PropTypes.string,

    talhoesSelecionados: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        area: PropTypes.number,
        culture: PropTypes.shape({}),
        details: PropTypes.string,
        landId: PropTypes.number,
        name: PropTypes.string,

        polygon: PropTypes.arrayOf(
          PropTypes.shape({
            lat: PropTypes.number,
            lon: PropTypes.number,
          }),
        ),
      }),
    ),
  }).isRequired,
};
Details.defaultProps = {};

export default Details;
